import { gql } from '@apollo/client';

/** Current authenticated user (used to resolve the vendor identity). */
export const CURRENT_USER = gql`
  query CurrentUser {
    currentUser {
      canSell
      city
      country
      currentMode
      createdAt
      email
      employeeRole
      fullName
      id
      isActive
      isVendor
      isVerified
      lastLogin
      phone
      profilePic
      state
      userType
      username
      vendorProfilePic
    }
  }
`;

/** The current vendor's shop profile + product count (header / dashboard). */
export const VENDOR_PROFILE = gql`
  query GetVendorProfile {
    vendorProfile {
      productCount
      profile {
        acceptsNotifications
        autoAcceptOrders
        businessDescription
        businessEmail
        businessName
        businessPhone
        businessType
        city
        country
        createdAt
        currentLatitude
        currentLongitude
        gst
        id
        is24Hours
        isActive
        isOnline
        isVerified
        lastSeen
        location
        logoUrl
        minOrderValue
        operatingHours
        pan
        postalCode
        profilePic
        rating
        state
        street1
        street2
        totalOrders
        updatedAt
        userId
        vendorCategories
        vendorType
        licenseUrl
        menuUrl
        isUseOtp
        daysActive
        preferredLanguage
        disableSearchNotifications
        openTime
        closeTime
      }
    }
  }
`;

/**
 * All shops owned by a vendor (a user can run more than one shop). The full
 * profile is selected so the shop-edit form can prefill from any shop.
 */
export const MY_SHOPS = gql`
  query MyShops($vendorId: String!, $userLat: Float, $userLong: Float) {
    myShops(vendorId: $vendorId, userLat: $userLat, userLong: $userLong) {
      distanceKm
      deliveryTimeMinutes
      profile {
        acceptsNotifications
        autoAcceptOrders
        businessDescription
        businessEmail
        businessName
        businessPhone
        businessType
        city
        country
        createdAt
        currentLatitude
        currentLongitude
        gst
        id
        is24Hours
        isActive
        isOnline
        isVerified
        lastSeen
        location
        logoUrl
        minOrderValue
        operatingHours
        pan
        postalCode
        profilePic
        rating
        state
        street1
        street2
        totalOrders
        updatedAt
        userId
        vendorCategories
        vendorType
        licenseUrl
        menuUrl
        isUseOtp
        daysActive
        preferredLanguage
        disableSearchNotifications
        openTime
        closeTime
        displayName
        businessImageUrl
      }
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UserProfileUpdateInput!) {
    updateProfile(input: $input) {
      success
      message
      daysActive
      isUseOtp
      errors {
        code
        field
        message
      }
      user {
        id
        fullName
        email
        phone
        city
        country
        currentMode
        isVendor
        isActive
        canSell
        userType
        username
      }
    }
  }
`;

export const REGISTER_DEVICE_TOKEN = gql`
  mutation RegisterDeviceToken($deviceToken: String!, $platform: String!, $deviceId: String) {
    registerDeviceToken(deviceToken: $deviceToken, platform: $platform, deviceId: $deviceId) {
      canSell
      message
      success
      vendorProfile
    }
  }
`;
